module.exports = [{"name":"U de Chile","id":"uchile","floors":[{"name":"-1","url":"/p-1.png"},{"name":"1","url":"/p1.png"},{"name":"2","url":"/p2.png"},{"name":"3","url":"/p3.png"}],"h":669,"w":1522,"stores_url":"REACT_APP_STORES"}]


//////////////////
// WEBPACK FOOTER
// ./src/mp-config.json
// module id = ./src/mp-config.json
// module chunks = 0